module.exports = __webpack_public_path__ + "assets/img/sd_img.0d79794e.png";